import _ from 'lodash'

import { connect } from 'react-redux'

import Chart, { IChartProps } from './Chart'
import { IChartPoint, IState, } from './types'

// from qualcomm datasheet APQ8084-Tsens_Numbered.pdf sensor layout map
export const individualTempKeysGen2i: string [] = [
  '0-board-near-cpu3',
  '1-board-bottom-left',
  '2-board-right-middle',
  '3-board-top-left',
  '4-board-middle',
  '5-cpu0',
  '6-cpu1',
  '7-cpu2',
  '8-cpu3',
  '9-gpu-top',
  '10-gpu-bottom',
]

// from qualcomm datasheet provided by Wade Pentz.
// my best approximation at naming them, due to them
// simply being green dots on a rough diagram of
// the chip's dye.
export const individualTempKeysGen3: string [] = [
  '0-board-top-right-first',
  '1-board-under-cpu',
  '2-board-left-cpu',
  '3-cpu0-first',
  '4-cpu0-second',
  '5-cpu1-first',
  '6-cpu1-second',
  '7-cpu0-third',
  '8-cpu3-first',
  '9-cpu3-second',
  '10-cpu4-first',
  '11-cpu4-second',
  '12-cpu3-third',
  '13-board-camera',
  '14-gpu-top',
  '15-gpu-bottom',
  '16-board-top-right-second',
  '17-board-dsp',
  '18-board-mdss',
  '19-board-right',
  '20-board-modem',
]

export const averagedTempKeys: string[] = [
  '0-cpu-average',
  '1-gpu-average',
  '2-all-average',
]

const mapStateToProps = (state: IState): IChartProps => {
  const data: IChartPoint[] = _
    .chain(state.chartPoints)
    .filter((point: IChartPoint) => point.chartType === 'TEMPERATURE')
    .sortBy('timestamp')
    .value()

  return {
    data,
    keys: averagedTempKeys,
  }
}

export default connect(mapStateToProps)(Chart)



// WEBPACK FOOTER //
// ./src/Temperature.tsx